import { render, staticRenderFns } from "./validPwd.vue?vue&type=template&id=2a4c51fe&scoped=true&"
import script from "./validPwd.vue?vue&type=script&lang=js&"
export * from "./validPwd.vue?vue&type=script&lang=js&"
import style0 from "./validPwd.vue?vue&type=style&index=0&id=2a4c51fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4c51fe",
  null
  
)

export default component.exports